/**
 * Formats a date-only value (a Postgres `date`, such as a birthdate or a baptism date) as the calendar day it is.
 *
 * Never pass one of these through `new Date(value)`: an ISO date with no time is parsed as midnight UTC, which is
 * the previous evening anywhere west of Greenwich, so the day shown is one earlier than the day stored. The parts
 * are read directly and the date is built in local time instead, so there is no time zone for the day to move in.
 *
 * Timestamps (`created_at` and the like) are a different thing, have a time zone, and should go through `Date`.
 */
export function formatDateOnly(
  value: string | null | undefined,
  locale?: string,
  options: Intl.DateTimeFormatOptions = {},
): string {
  if (value === null || value === undefined) return "";
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (match === null) return "";
  const [, year, month, day] = match;
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  return date.toLocaleDateString(locale, options);
}
